<script>
  const baseApi = process.env.BASE_API;
  export default{
    baseApi
  }
</script>



// WEBPACK FOOTER //
// src/components/Global.vue